<template>
  <div class="title bg-success">Políticas de Horário</div>
  <div class="container">
    <table class="table table-sm table-striped">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="border px-4 py-2">Nome</th>
          <!-- <th class="border px-4 py-2">Empresa</th> -->
          <th class="border px-4 py-2">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="policy in schedules" :key="policy.id">
          <td class="border px-4 py-2">{{ policy.name }}</td>
          <!-- <td class="border px-4 py-2">{{ policy.company?.name || '-' }}</td> -->
          <td class="border px-4 py-2 space-x-2">
            <div class="d-flex gap-1">
              <button class="btn btn-sm btn-primary me-2" @click="editPolicy(policy)">Editar</button>
              <button class="btn btn-sm btn-danger" @click="confirmDelete(policy)">Excluir</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <br>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <button class="btn btn-primary" @click="addPolicy">Adicionar</button>
    </div>
    
    <ModalContent 
      :is-modal-open="!!deletingPolicy" 
      @close="cancelDelete" 
      @send="deletePolicy" 
      :title="`Excluir Política`">
      Você tem certeza que deseja excluir a política "{{ deletingPolicy?.name }}" ?
    </ModalContent>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { schedulePolicyService } from '@/services/backend/ApiService';
import { ListManager } from '@/services/manager/ListManager';
import ModalContent from '@/components/ModalContent.vue';

const router = useRouter();
const listManager = new ListManager(schedulePolicyService);
const schedules = listManager.items;
const deletingPolicy = ref<any>(null);

const editPolicy = (policy: any) => {
  router.push(`/agendamentos/${policy.id}?mode=edit`);
};

const addPolicy = () => {
  listManager.add({});
};

const confirmDelete = (policy: any) => {
  deletingPolicy.value = policy;
};

const deletePolicy = async () => {
  if (deletingPolicy.value) {
    await listManager.remove(deletingPolicy.value.id);
    deletingPolicy.value = null;
  }
};

const cancelDelete = () => {
  deletingPolicy.value = null;
};

onMounted(() => listManager.fetchAll());
</script>

<style scoped>
.badge {
  font-size: 0.95em;
}

th:last-child,
td:last-child {
  width: 1%;
  white-space: nowrap;
}
</style>
